// RAWG API setup
const API_KEY = "b6aec36ae27845538b01577b5b1836a7";
const BASE_URL = "https://api.rawg.io/api";

// Your custom backend API base
const BACKEND_URL = "https://gamedb-du10.onrender.com/api/v1";


// ---------- RAWG API Calls ----------

// Fetch list of games
export const fetchGames = async (page = 1, filters = {}) => {
  let url = `${BASE_URL}/games?key=${API_KEY}&page=${page}`;
  if (filters.genre) url += `&genres=${filters.genre}`;
  if (filters.platform) url += `&platforms=${filters.platform}`;
  if (filters.year) url += `&dates=${filters.year}-01-01,${filters.year}-12-31`;
  if (filters.ordering) url += `&ordering=${filters.ordering}`;

  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch games");
  return res.json();
};

// Search games
export const searchGames = async (query, page = 1) => {
  const url = `${BASE_URL}/games?key=${API_KEY}&search=${query}&page=${page}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to search games");
  return res.json();
};

// Fetch single game details
export const fetchGameDetails = async (id) => {
  const url = `${BASE_URL}/games/${id}?key=${API_KEY}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch game details");
  return res.json();
};

// Fetch screenshots for a game
export const fetchGameScreenshots = async (id) => {
  const url = `${BASE_URL}/games/${id}/screenshots?key=${API_KEY}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch screenshots");
  const data = await res.json();
  return data.results || [];
};

// Fetch trailers for a game
export const fetchGameMovies = async (id) => {
  const url = `${BASE_URL}/games/${id}/movies?key=${API_KEY}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch movies");
  const data = await res.json();
  return data.results || [];
};

// ---------- Custom Backend API Calls ----------

// User Registration
export const registerUser = async (username, email, password) => {
  const url = `${BACKEND_URL}/users/register`;
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, email, password }),
  });
  return res.json();
};

// User Login
export const loginUser = async (email, password) => {
  const url = `${BACKEND_URL}/users/login`;
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  let data;
  try {
    data = await res.json();
  } catch (e) {
    // Non-JSON response (e.g., HTML error) -> normalize
    data = { error: `HTTP ${res.status} ${res.statusText}` };
  }
  if (!res.ok) {
    throw new Error(data.error || 'Login request failed');
  }
  return data;
};

// Add Review (needs JWT token)
export const addReview = async (gameId, text, rating, token) => {
  if (!token) {
    throw new Error("Authentication token required");
  }
  
  const url = `${BACKEND_URL}/reviews/${gameId}`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify({ text, rating }),
  });
  
  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.error || `HTTP error! status: ${res.status}`);
  }
  
  return res.json();
};

// Add game to wishlist
export const addToWishlist = async (userId, gameId, token) => {
  const url = `${BACKEND_URL}/wishlist`;
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify({ user_id: userId, game_id: gameId }),
  });
  return res.json();
};

// Remove game from wishlist
export const removeFromWishlist = async (userId, gameId, token) => {
  const url = `${BACKEND_URL}/wishlist/${userId}/${gameId}`;
  const res = await fetch(url, {
    method: "DELETE",
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });
  return res.json();
};

// Get user wishlist (general)
export const fetchWishlist = async (userId, token) => {
  const url = `${BACKEND_URL}/wishlist/${userId}`;
  const res = await fetch(url, {
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });
  return res.json();
};

// ---------- Profile Data API Calls ----------

// Fetch all reviews for a user
export const fetchUserReviews = async (userId, token) => {
  const url = `${BACKEND_URL}/reviews/user/${userId}`;
  const res = await fetch(url, {
    headers: {
      "Authorization": `Bearer ${token}`,
    },
  });
  return await res.json();
};

// Fetch game reviews
export const fetchGameReviews = async (gameId) => {
  const url = `${BACKEND_URL}/reviews/game/${gameId}`;
  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch game reviews");
  return await res.json();
};

// Update review
export const updateReview = async (reviewId, text, rating, token) => {
  const url = `${BACKEND_URL}/reviews/${reviewId}`;
  const res = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify({ text, rating }),
  });
  return res.json();
};

// Delete review
export const deleteReview = async (reviewId, token) => {
  const url = `${BACKEND_URL}/reviews/${reviewId}`;
  const res = await fetch(url, {
    method: "DELETE",
    headers: {
      "Authorization": `Bearer ${token}`,
    }
  });
  return res.json();
};
